import React from "react";
import { CtaBand } from "../components/CtaBand";
import { Faq } from "../components/Faq";
import { Seo } from "../components/Seo";
import { DataTable } from "../components/sections/DataTable";
import { FeatureGrid } from "../components/sections/FeatureGrid";
import { MediaSplit } from "../components/sections/MediaSplit";
import { PageHero } from "../components/sections/PageHero";
import { QuickAnswer } from "../components/sections/QuickAnswer";
import { RelatedPages } from "../components/sections/RelatedPages";
import { rinnaiFaqs } from "../data/faqs";
import { routes } from "../data/routes";
import { whyRinnaiHero, whyRinnaiInstaller, whyRinnaiQuickAnswer, whyRinnaiRange, whyRinnaiReasons, whyRinnaiService } from "../data/whyRinnai";
import { breadcrumbSchema, faqSchema } from "../utils/schema";
const RINNAI_LOGO = "https://cdn.magicpatterns.com/uploads/hFoDUb8JWxjP5f5MBMV5Em/image.png";
export function WhyRinnai() {
  return <>
      <Seo title="Why Choose Rinnai Air Conditioning? | Perth Rinnai Specialists" description="Why Perth homeowners choose Rinnai air conditioning: 50+ years in Australian homes, a 7 year warranty on eligible systems, 1stCare national service and efficient inverter technology." path={routes.whyRinnai} schema={[{
      "@type": "Brand",
      name: "Rinnai",
      url: "https://www.rinnai.com.au/",
      description: "Rinnai Australia supplies heating, cooling and hot water products to Australian homes and is part of Japan’s Rinnai Corporation."
    }, breadcrumbSchema([{
      name: "Home",
      path: routes.home
    }, {
      name: "Why Rinnai",
      path: routes.whyRinnai
    }]), faqSchema(rinnaiFaqs)]} data-id="element-467" data-mp="2xy9800d6dwmk" />
      <PageHero {...whyRinnaiHero} logo={{
      src: RINNAI_LOGO,
      alt: "Rinnai"
    }} defaultNeed="Not sure" data-id="element-468" data-mp="1jgqk26xwev8d" />
      <QuickAnswer id="why-rinnai-answer" {...whyRinnaiQuickAnswer} data-id="element-469" data-mp="1eiox3axcqbrm" />
      <FeatureGrid id="why-rinnai-reasons" eyebrow="SIX REASONS" title="Why Perth homeowners are choosing Rinnai." intro="Product quality, long-term support and a complete range under one trusted name." items={whyRinnaiReasons} background="soft" note="Features vary by model and series. Warranty terms and conditions apply." data-id="element-470" data-mp="1egcb8moh3h9a" />
      <MediaSplit id="why-rinnai-service" {...whyRinnaiService} data-id="element-471" data-mp="20ccfrfpetbva" />
      <DataTable id="why-rinnai-range" eyebrow="THE RINNAI RANGE" title="A Rinnai system for every Perth home." intro="From a single bedroom to a fully zoned smart home, the Rinnai group covers every residential need." columns={whyRinnaiRange.columns} rows={whyRinnaiRange.rows} background="soft" data-id="element-472" data-mp="258ktqprvez0v" />
      <MediaSplit id="why-rinnai-installer" {...whyRinnaiInstaller} reverse data-id="element-473" data-mp="jw9p1ihl7p29" />
      <Faq id="rinnai-faqs" items={rinnaiFaqs} eyebrow="RINNAI FAQs" title="Rinnai brand questions, answered." intro="Who makes Rinnai, what the warranty covers and who looks after your system." moreLink={{
      label: "See all FAQs",
      to: routes.faqs
    }} data-id="element-474" data-mp="jycmgnl2kkh0" />
      <RelatedPages current={routes.whyRinnai} data-id="element-475" data-mp="7ls2qj8jlmva" />
      <CtaBand title="Ready to choose your Rinnai system?" text="Free quote · Rinnai specialists · ARC Tick licensed installation" data-id="element-476" data-mp="7mjypv61xmm3" />
    </>;
}